// create a Map with all the blocks and their appropriate
// order variables

export interface IBlockForSelect {
  id: number;
  name: string;
  dropdownName: string;
}

export const blocksForSelect: IBlockForSelect[] = [
  // { id: 29, name: 'subject', dropdownName: 'Subject' },
  // { id: 30, name: 'preheader', dropdownName: 'Preheader' },
  { id: 2, name: 'main-banner', dropdownName: 'Main Banner' },
  { id: 3, name: 'counter', dropdownName: 'Counter' },
  { id: 4, name: 'paragraph-cta', dropdownName: 'Intro + CTA' },
  { id: 27, name: 'only-intro', dropdownName: 'OnlyIntro' },
  { id: 26, name: 'disclaimer', dropdownName: 'Disclaimer' },
  { id: 13, name: 'heading', dropdownName: 'BigHeadline' },
  { id: 25, name: 'only-cta', dropdownName: 'OnlyCTA' },
  {
    id: 6,
    name: 'property-usp-2x-photo',
    dropdownName: 'Property, USP, 2x Photo',
  },
  {
    id: 10,
    name: 'property-usp-1x-photo',
    dropdownName: 'Property, USP, 1x Photo',
  },
  {
    id: 12,
    name: 'x2-prop-rec',
    dropdownName: '2xProperty Destination Name',
  },
  {
    id: 11,
    name: 'property-description',
    dropdownName: 'Property Description',
  },
  {
    id: 23,
    name: 'x2-prop-rec-onp',
    dropdownName: '2x Property Recommendation Old/New Price',
  },
  { id: 24, name: 'reviews', dropdownName: 'Reviews' },
  {
    id: 9,
    name: 'zigzag-heading-and-alt-cta',
    dropdownName: 'ZigZag Heading And Alternate CTA',
  },
  {
    id: 8,
    name: 'zigzag-heading-and-cta',
    dropdownName: 'ZigZag Heading And CTA',
  },
  {
    id: 7,
    name: 'zigzag-no-heading-no-button',
    dropdownName: 'ZigZag No Heading No Button',
  },
  { id: 22, name: 'inspiration', dropdownName: 'Inspiration 2xfotoHeading' },
  { id: 15, name: 'event', dropdownName: 'InspirationFotoDES' },
  {
    id: 19,
    name: 'x2-experiences',
    dropdownName: 'Inspiration 2xfotoHeadingDES',
  },
  {
    id: 20,
    name: 'x3-experiences',
    dropdownName: 'Inspiration 3xfotoHeading',
  },
  { id: 28, name: 'only-2-photos', dropdownName: 'Only2Photos' },
  { id: 1, name: 'voucher', dropdownName: 'Voucher' },
  { id: 5, name: 'gift-voucher', dropdownName: 'Gift Voucher CTA' },
  {
    id: 16,
    // concierge is the name of the component
    name: 'experience-concierge',
    dropdownName: 'Gift voucher noCTA',
  },
  { id: 21, name: 'moments', dropdownName: 'Moments' },
  {
    id: 14,
    name: 'reservation',
    dropdownName: 'Reservation, contact + address',
  },
  { id: 17, name: 'check-in', dropdownName: 'Check In' },
  { id: 18, name: 'valamar-app', dropdownName: 'Valamar App' },
];

// Block catalog for the Google RSA search editor (separate from the email catalog).
export const rsaBlocksForSelect: IBlockForSelect[] = [
  { id: 101, name: 'rsa-search-image', dropdownName: 'Images' },
  { id: 102, name: 'sitelink', dropdownName: 'Sitelink' },
  { id: 103, name: 'rsa-search-calls', dropdownName: 'Calls' },
  { id: 104, name: 'rsa-search-callouts', dropdownName: 'Callouts' },
];

// Block catalog for the Google Performance Max editor: only sitelinks are added on demand.
export const pmaxBlocksForSelect: IBlockForSelect[] = [
  { id: 201, name: 'pmax-sitelink', dropdownName: 'Sitelink' },
];

// Block catalog for the Google YouTube Video Ad editor: only sitelinks are added on demand.
export const youtubeVideoBlocksForSelect: IBlockForSelect[] = [
  { id: 301, name: 'youtube-video-sitelink', dropdownName: 'Sitelink' },
];

// Block catalog for the Meta Carousel Ad editor: only cards are added on demand.
export const metaCarouselBlocksForSelect: IBlockForSelect[] = [
  { id: 401, name: 'meta-carousel-card', dropdownName: 'Card' },
];
